"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._throwTypeGuardError = void 0;
const TypeGuardError_1 = require("../TypeGuardError");
const _throwTypeGuardError = (props) => {
    throw new TypeGuardError_1.TypeGuardError(props);
};
exports._throwTypeGuardError = _throwTypeGuardError;
//# sourceMappingURL=_throwTypeGuardError.js.map